"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.registerAll = exports.get = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var onceOnly_sidecar_1 = require("@lib/onceOnly-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var _default = {
    type: 'default',
    frames: sprites_sidecar_1.sprites.voyTileParticlesRound,
    // bounceOnSurface: true,
    accelY: 2,
    minTimeSeconds: 0,
    maxTimeSeconds: 2,
    playFrames: false,
    dirXrange: [-1, 1],
    dirYrange: [-0.1, -1],
    sineX: 0,
    sineXperiod: 0,
    afterCreate: null,
    scale: 1,
};
var dataType = 'particles';
var dataList = [];
var dataMapType = {};
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
};
exports.get = get;
var registerAll = function () {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    exports.register(_default);
    exports.register({
        type: 'fire-extinguisher',
        frames: sprites_sidecar_1.sprites.voyTileParticlesRound,
        accelY: 0,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.25,
        playFrames: true,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        sineX: 4,
        sineXperiod: 5,
    });
    exports.register({
        type: 'steam',
        frames: [sprites_sidecar_1.sprites.voyTileParticlesRound[1]],
        accelY: 0,
        minTimeSeconds: 0.4,
        maxTimeSeconds: 0.9,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        sineX: 4,
        sineXperiod: 5,
        afterCreate: function (p) {
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, 1);
            p.fade = true;
        },
    });
    exports.register({
        type: 'zzz',
        frames: sprites_sidecar_1.sprites.voyTileParticlesZ,
        accelY: 0,
        minTimeSeconds: 1,
        maxTimeSeconds: 2,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.2],
        sineX: 4,
        sineXperiod: 5,
        afterCreate: function (p) {
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, 1);
            // p.image.tint = voyageColors.red
            p.fade = true;
        },
    });
    exports.register({
        type: 'oxygen',
        frames: sprites_sidecar_1.sprites.voyTileParticlesCircle,
        accelY: 0,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.25,
        playFrames: true,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        sineX: 4,
        sineXperiod: 5,
        afterCreate: function (p) {
            p.fade = true;
        },
    });
    exports.register({
        type: 'heal',
        frames: [sprites_sidecar_1.sprites.voyTilePluses[1]],
        accelY: 0,
        minTimeSeconds: 1,
        maxTimeSeconds: 2.0,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        sineX: 4,
        sineXperiod: 5,
        //scale: 0.25,
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.green;
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, 1);
            p.fade = true;
        },
    });
    exports.register({
        type: 'teleport',
        frames: [sprites_sidecar_1.sprites.voyTileParticlesRound[1]],
        accelY: 0,
        minTimeSeconds: 1,
        maxTimeSeconds: 2.0,
        playFrames: false,
        dirXrange: [-0.3, 0.3],
        dirYrange: [-0.1, -0.9],
        sineX: 4,
        sineXperiod: 5,
        //scale: 0.25,
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.green;
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, 2);
            p.fade = true;
        },
    });
    exports.register({
        type: 'weapon-hit',
        frames: [sprites_sidecar_1.sprites.voyTileParticlesRound[1]],
        accelY: 0,
        minTimeSeconds: 1.5,
        maxTimeSeconds: 4.0,
        playFrames: false,
        dirXrange: [-0.5, 0.5],
        dirYrange: [-0.2, -0.9],
        sineX: 4,
        sineXperiod: 5,
        //scale: 0.25,
        afterCreate: function (p) {
            //p.image.tint = voyageColors.green
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, rando_sidecar_1.rando.i(1, 6));
            p.fade = true;
        },
    });
    exports.register({
        type: 'heal-hull',
        frames: [sprites_sidecar_1.sprites.voyTilePluses[1]],
        accelY: 0,
        minTimeSeconds: 1,
        maxTimeSeconds: 2.0,
        playFrames: false,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        sineX: 4,
        sineXperiod: 5,
        //scale: 0.25,
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.g3;
            spritesUtil_sidecar_1.spritesUtil.scale(p.image, 1);
            p.fade = true;
        },
    });
    exports.register({
        type: 'laser',
        frames: [sprites_sidecar_1.sprites.voyTileParticlesRound[0]],
        accelY: 0,
        minTimeSeconds: 4,
        maxTimeSeconds: 4,
        playFrames: true,
        dirXrange: [0, 0],
        dirYrange: [0, 0],
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.red;
            p.dirX = 10;
        },
    });
    exports.register({
        type: 'torpedo',
        //frames: [sprites.voyItemTorpedo[0]],
        frames: [sprites_sidecar_1.sprites.voyInkItemTorpedo[0]],
        accelY: 0,
        minTimeSeconds: 4,
        maxTimeSeconds: 4,
        playFrames: true,
        dirXrange: [0, 0],
        dirYrange: [0, 0],
        afterCreate: function (p) {
            // p.image.tint = voyageColors.damage
            p.dirX = 5;
            p.image.flipX = false;
            p.image.scale = 0.3;
        },
    });
    exports.register({
        type: 'blood-crew',
        frames: sprites_sidecar_1.sprites.voyTileParticlesRound,
        accelY: 0.5,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.75,
        playFrames: true,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.red;
        },
    });
    exports.register({
        type: 'blood-alien',
        frames: sprites_sidecar_1.sprites.voyTileParticlesRound,
        accelY: 0.5,
        minTimeSeconds: 0.5,
        maxTimeSeconds: 1.75,
        playFrames: true,
        dirXrange: [-0.2, 0.2],
        dirYrange: [-0.1, -0.3],
        afterCreate: function (p) {
            p.image.tint = voyageColors_sidecar_1.voyageColors.green;
        },
    });
};
exports.registerAll = registerAll;
var register = function (data) {
    entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
};
exports.register = register;
